// extracted by css-extract-rspack-plugin
export default {"container":"LegalDisclaimer-module__container__hIsFALk"};